/* @flow */

import { callLiferayEndpoint } from './index';
import utils from './utils';

import type { Producer } from 'types';

const find = async (): Promise<Producer[]> => {
  const endpoint = '/protones-portlet.produttori/find-all';
  const response = await callLiferayEndpoint(endpoint, {});
  return response.map(utils.toProducer);
};

export default {
  find,
};
